<section *transloco="let t" class="relative py-12 sm:py-24">
  <!-- Full-bleed Accent Background -->
  <div class="absolute inset-y-0 left-1/2 -z-10 w-screen -translate-x-1/2 bg-accent-500"></div>

  <div class="grid gap-8 lg:grid-cols-3 lg:items-center lg:gap-12">
    <!-- Title & Subtitle -->
    <div class="lg:col-span-1">
      <h2 class="text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl">
        {{ t('home.trusted.title') }}
      </h2>
      <p class="mt-4 text-base text-white/90 sm:mt-6 sm:text-xl">
        {{ t('home.trusted.subtitle') }}
      </p>
    </div>

    <!-- Testimonials -->
    <div class="space-y-5 lg:col-span-2 sm:space-y-6">
      @for (testimonial of testimonials; track testimonial.name) {
        <figure class="rounded-2xl bg-white p-6 shadow-lg sm:rounded-3xl sm:p-10">
          <figcaption class="text-2xl font-semibold text-slate-900 sm:text-3xl">
            {{ testimonial.name }}
          </figcaption>
          <blockquote class="mt-3 text-base leading-relaxed text-slate-600 sm:text-xl">
            {{ testimonial.quote }}
          </blockquote>
        </figure>
      }
    </div>
  </div>
</section>
